import React from 'react'
import { CFView, LocationSelect, MobileScreen } from 'components'
import Header from './Header'
import Hero from './Hero'
import Promotions from './Promotions'
import About from './About'
import Gallery from './Gallery'
import Contact from './Contact'
import Footer from './Footer'
import { homebg } from 'images'

export default () => {
  return (
    <CFView row justifyCenter>
      <CFView
        maxWidth="1400px"
        w="100%"
        image={`url(${homebg}) center / contain repeat`}
      >
        {/* <MobileScreen>
          <LocationSelect />
        </MobileScreen> */}
        {/* <Header /> */}
        <Hero />
        <Promotions />
        <About />
        <Gallery />
        <Contact />
        <Footer />
      </CFView>
    </CFView>
  )
}
